import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'PaymentTerm';
const ENDPOINT = `/payment-terms/`;

@Injectable({
    providedIn: 'root'
})
export class PaymentTermService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
